export default __webpack_public_path__ + "static/media/dust.344a95e1.mp4";